import { COLORS, FONTS } from '../../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');

  return {
    actionsRow: {
      marginTop: 50,
    },
    formButtons: {
      display: 'flex',

      '& > button': {
        flex: '1',
      },
      '& > button:first-child': {
        marginRight: 5,
      },
      '& > button:last-child': {
        marginLeft: 5,
      },
    },
    formGroup: {
      marginTop: 24,

      '& .MuiSwitch-colorSecondary.Mui-checked': {
        color: '#4caf50 !important',
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#4caf50 !important',
      },
      ' & .MuiSwitch-colorSecondary.Mui-disabled': {
        color: '#bdbdbd !important',
      },
      // '& .MuiSwitch-colorSecondary.Mui-checked': {
      //   color: '#4caf50',
      // },

      '& p#personal-phone-text-field-helper-text': {
        bottom: -29,
        display: 'contents',
      },

      '& p#mobile-phone-text-field-helper-text': {
        bottom: -29,
        display: 'contents',
      },
      '& .MuiTextField-root,.MuiInputBase-input': {
        width: '100%',
      },
    },
    approvalStatusContainer: {
      border: '1px solid #E6E8EC',
      borderRadius: 5,
      padding: '1rem',
      marginTop: '2rem',
      [minSm]: {
        display: 'none',
      },
    },
    approvalStatus: {
      fontFamily: FONTS.PRIMARY,
      fontSize: '0.90rem',
      color: '#333333',
      backgroundColor: '#FBB52E',
      display: 'inline-block',
      borderRadius: '20px',
      padding: '7px 14px',
      marginBottom: '0.75rem',
    },
    approvalStatusText: {
      fontSize: '0.95rem',
      lineHeight: '1.5',
    },
    textLabel: {
      fontFamily: FONTS.PRIMARY,
      textTransform: 'uppercase',
      color: COLORS.GREY_DARKER,
      fontSize: '0.75rem',
      fontWeight: 600,
    },
    textValue: {
      fontFamily: FONTS.PRIMARY,
      fontWeight: 300,
      fontSize: '1rem',
      color: COLORS.GREY_DARK,
      padding: '6px 0 7px',
      wordWrap: 'break-word',
      whiteSpace: 'pre-line',
    },
    textWrapper: {
      marginBottom: '10px',
    },
  };
};

export default styles;
